import React, { useState } from "react";
import { Box, Card, CardActions, TextField, Typography } from "@mui/material";
import { useResponsiveContext } from "contexts/ResponsiveContextContainer";
import { Button, Form, useTranslate } from "react-admin";
import SwitchLang from "components/SwitchLang";

const Login = () => {
  const t = useTranslate();
  const { isPhone } = useResponsiveContext();
  const [company, setCompany] = useState("");
  const handleCompanyChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setCompany(value);
      return;
    }
    if (/^[a-z0-9_-]+$/.test(value)) {
      value = value.toLowerCase();
      setCompany(value);
    }
  };

  const handleSubmit = () => {
    if (!company) return;
    window.location.href = `https://${company}.` + process.env.REACT_APP_DOMAIN;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "flex-start",
        // background: "url(/bg.jpg)",
        // backgroundRepeat: "no-repeat",
        // backgroundSize: "cover",
        position: "relative",
      }}
    >
      <Box sx={{ position: "absolute", top: 32, right: 32 }}>
        <SwitchLang noLayout />
      </Box>
      <Card
        sx={{
          width: isPhone ? "calc(100vw - 32px)" : "450px",
          marginTop: "6em",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <img src='/logo.jpg' alt="logo" width={400} />
        </Box>
        <Typography
          variant="h4"
          sx={{ textAlign: "center", marginBottom: "1em" }}
        >
          {t("pos.title")}
        </Typography>
        <Form id="login-form" onSubmit={handleSubmit}>
          <Box sx={{ padding: "0 1em 0 1em" }}>
            {/* <Box sx={{ textAlign: "center", mb: 2 }}>
              <img
                src="/logo.jpg"
                alt="logo2"
                style={{ maxWidth: 335, maxHeight: 70 }}
              />
            </Box> */}
            <Box sx={{ padding: "0 1em 1em 0em" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  autoFocus
                  label={t("pos.companyLabel")}
                  fullWidth
                  variant="outlined"
                  value={company}
                  onChange={handleCompanyChange}
                />
                <Typography variant="h6">.brickfox.io</Typography>
              </Box>
            </Box>
          </Box>
        </Form>
        <CardActions sx={{ padding: `1em 1em 1em 1em` }}>
          <Button
            label="pos.submitButton"
            fullWidth
            variant="contained"
            size="large"
            type="submit"
            form="login-form"
          />
        </CardActions>
        {/* <Box sx={{ marginY: "1em", display: "flex", justifyContent: "center" }}>
          <Link to="/">{t("pos.link")}</Link>
        </Box> */}
      </Card>
    </Box>
  );
};

export default Login;
